import {EventResponse} from "../../data/events/EventResponse";
import useApiCall from "../../hooks/CancellableApiCall";
import {EventList} from "../event/EventList";
import {LoadingContent} from "../LoadingContent";
import React from "react";
import useUser from "../../hooks/useUser";

interface CCMeetingPanelContentProps {
    events: EventResponse[]
    canCreateEvents: boolean
}

const CCMeetingPanelContent = (props: CCMeetingPanelContentProps) => {
    return <EventList
        events={props.events}
        preloadedEventType={"cc-meet"}
        canCreateEvents={props.canCreateEvents}
    />
}

export const CCMeetingPanel = () => {
    const loadCCEvents = useApiCall<EventResponse[]>({
        initialUrl: `/api/event/type/cc-meet`
    })
    const user = useUser()

    return <LoadingContent showLoadingSkeleton isLoading={
        loadCCEvents.isLoading || !loadCCEvents.data
    }>
        <CCMeetingPanelContent
            events={loadCCEvents.data!!}
            canCreateEvents={user.hasPermissions("complaint_committee-events:create")}
        />
    </LoadingContent>
}